import type { ReactElement } from 'react';
import { ProcessStepItem } from './process-step-item';
import { PROCESS_STEPS } from './process-steps';

/**
 * 회사 소개 "How it works" — 디자인부터 제작·배송까지 다섯 단계.
 * 넓은 화면은 가로 타임라인, 좁은 화면은 세로 타임라인이다.
 */
export const AboutProcess = (): ReactElement => (
  <section aria-labelledby="about-process-heading" className="flex flex-col gap-10 sm:gap-14">
    <header className="flex flex-col gap-4">
      <h2
        id="about-process-heading"
        className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
      >
        <span aria-hidden>How it works</span>
        <span className="sr-only">제작 과정</span>
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        재고 없이 주문마다 제작합니다. 디자인에서 배송까지 다섯 단계로 진행돼요.
      </p>
    </header>

    <ol className="grid lg:grid-cols-5">
      {PROCESS_STEPS.map((step, index) => (
        <ProcessStepItem
          key={step.title}
          step={step}
          order={index + 1}
          isLast={index === PROCESS_STEPS.length - 1}
        />
      ))}
    </ol>
  </section>
);
